import { useCallback, useRef } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

const PRE_MADE_POST_MODULE_VIEW_EVENT_NAME = 'petition_manage_ready_to_share_posts_view_v2_pre_drafted';
const PRE_MADE_POST_MODULE_EVENT_COMMON_PROPERTIES = {
	context: 'petition_dashboard_ready_to_share_post_pre_drafted',
	view_context: 'petition_dashboard_ready_to_share_post_pre_drafted',
};

type UseViewTrackingResult = {
	trackView: (currentPosition: string) => void;
};

export function useViewTracking(): UseViewTrackingResult {
	const track = useTracking();
	const isTrackedRef = useRef(false);

	// Track view event
	const trackView = useCallback(
		(currentPosition: string) => {
			if (isTrackedRef.current || currentPosition === 'below') {
				return;
			}
			void track(PRE_MADE_POST_MODULE_VIEW_EVENT_NAME, PRE_MADE_POST_MODULE_EVENT_COMMON_PROPERTIES);
			isTrackedRef.current = true;
		},
		[track],
	);

	return {
		trackView,
	};
}
